export function getUtmTagsFromUrl() {
  const urlParams = new URLSearchParams(window.location.search);
  const tags: Record<string, string> = {};

  Array.from(urlParams.keys())
    .filter((key) => key.startsWith('utm_'))
    .forEach((key) => {
      const value = urlParams.get(key);
      if (value) tags[key] = value;
    });

  return tags;
}
